<template>
  <b-container fluid>

    <!-- Service Type: Financial -->
    <b-row>
      <b-col xs="12" sm="12" md="12" lg="12" xl="12">
        <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
              <b-form  @submit.prevent="handleSubmit(makePayment)" @reset.prevent="reset" enctype="multipart/form-data">
                <ValidationProvider name="Amount" vid="amount" rules="required|numeric">
                  <b-form-group
                      class="row"
                      label-cols-sm="2"
                      label-for="amount"
                      slot-scope="{ valid, errors }"
                      >
                      <template v-slot:label>
                        {{$t('hospital_public_panel.amount')}} <span class="text-danger">*</span>
                      </template>
                      <b-form-input
                        plain
                        v-model="financial.amount"
                        id="amount"
                        :state="errors[0] ? false : (valid ? true : null)"
                      >
                      </b-form-input>
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                  </b-form-group>
                </ValidationProvider>
                <div class="col text-right">
                  <b-button type="submit" variant="primary" class="mr-2">{{ $t('hospital_public_panel.pay_now')}}</b-button>
                </div>
              </b-form>
        </ValidationObserver>
      </b-col>
    </b-row>

  </b-container>
</template>
<script>

import { ValidationObserver, ValidationProvider } from 'vee-validate'

export default {
  props: ['hospitalId'],
  components: {
    ValidationObserver,
    ValidationProvider
  },
  data () {
    return {
      financial: {
        amount: ''
      }
    }
  },
  computed: {
  },
  created () {
  },
  mounted () {
  },
  watch: {
  },
  methods: {
      makePayment () {
      }
  }
}
</script>
